import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_MGMT_BILLING_SERVICE_BASE,
  async deleteCourierCOG(monthYear) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/DeleteCourierCOG/${monthYear}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async deleteFixedCostItem(id) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/DeleteFixedCost/${id}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async deleteBudgetItem(id) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/DeleteBudget/${id}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadCourierCOG() {
    await authentication.isAuthenticated();
    return axios
      .get(this.baseUrl + "/GetCourierCOG", {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadFixedCostItems() {
    await authentication.isAuthenticated();
    return axios
      .get(this.baseUrl + "/GetFixedCost", {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadBudgetItems() {
    await authentication.isAuthenticated();
    return axios
      .get(this.baseUrl + "/GetBudget", {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async saveCourierCOG(settings) {
    await authentication.isAuthenticated();
    return axios
      .post(this.baseUrl + "/SaveCourierCOG", settings, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async saveFixedCostItems(settings) {
    await authentication.isAuthenticated();
    return axios
      .post(this.baseUrl + "/SaveFixedCost", settings, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async saveBudgetItems(settings) {
    await authentication.isAuthenticated();
    return axios
      .post(this.baseUrl + "/SaveBudget", settings, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
